import * as tripFinderActions from '../actions/trip-finder.actions';
import * as tripFinderState from '../states/trip-finder.state';

export class State extends tripFinderState.State { }

const initialState: tripFinderState.State = tripFinderState.initialState;

export function reducer(state: State = initialState,
	action: tripFinderActions.Actions): tripFinderState.State {
	switch (action.type) {
		case tripFinderActions.ActionTypes.LOADING:
			state = Object.assign({}, state, { loading: true });
			return state;
		case tripFinderActions.ActionTypes.PUT_SEARCH_PARAMETERS:
			state = Object.assign({}, state, { loading: true, search: action.payload });
			return state;
		case tripFinderActions.ActionTypes.PUT_OFFERS:
			state = Object.assign({}, state, { loading: false, offers: action.payload });
			return state;
		case tripFinderActions.ActionTypes.PUT_SELECTED_OFFER:
			state = Object.assign({}, state, { loading: false, selectedOffer: action.payload });
			return state;
		case tripFinderActions.ActionTypes.RESET:
			state = Object.assign({}, state, initialState);
			return state;
		default:
			return state;
	}
}

export const getLoading = (state: tripFinderState.State) => state.loading;
export const getSearchParameters = (state: tripFinderState.State) => state.search;
export const getOffers = (state: tripFinderState.State) => state.offers;
export const getSelectedOffer = (state: tripFinderState.State) => state.selectedOffer;

